import script from "./profile-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./profile-settings.vue?vue&type=script&setup=true&lang=js"

import "./profile-settings.vue?vue&type=style&index=0&id=d3bd9ae8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3bd9ae8"]])

export default __exports__